import React, { MouseEvent } from "react";
import clsx from "clsx";
import s from "~/components/Table/TableRow/DefaultTableRow/TableRow.less";
import Button from "~/shared/ui/Fields/Button";
import Default from "~/components/Icons/icon-default";
import Delete from "~/components/Icons/delete-cross";
import {
  openDelModal_DefaultTableRow,
  openEditModal_DefaultTableRow,
  openEditStatusModal_DefaultTableRow,
  openRestoreModal_DefaultTableRow,
  openViewModal_DefaultTableRow,
} from "~/components/Table/TableRow/DefaultTableRow/utils";
import { useHistory } from "react-router-dom";
import { useSetLocationData } from "~/hooks/locationData";
import { useTranslation } from "react-i18next";
import Download from "~/components/Icons/default/Download";

const ButtonResolver = ({
  type,
  item,
  btnEdit,
  btnView,
  btnEditStatus,
  btnDel,
  btnDownload,
  btnCustom,
}) => {
  const { t } = useTranslation();
  const history = useHistory();
  const setData = useSetLocationData();

  const isUsersType = type === "users";

  const restore =
    type === "editorSubdivision" ||
    item.status === "active" ||
    type === "employee" ||
    type === "documentLib.table" ||
    type === "cameraZones.table" ||
    type === "photoGallery.table" ||
    type === "patp" ||
    type === "cameraView.table" ||
    type === "domains_table" ||
    type === "ivideonPlans.table" ||
    type === "directions";

  const openEditModal = openEditModal_DefaultTableRow(
    type,
    item,
    setData,
    history
  );
  const openViewModal = openViewModal_DefaultTableRow(
    type,
    item,
    setData,
    history
  );
  const openEditStatusModal = openEditStatusModal_DefaultTableRow(
    setData,
    item
  );
  const openDelModal = openDelModal_DefaultTableRow(setData, item, type);
  const openRestoreModal = openRestoreModal_DefaultTableRow(setData, item);

  return (
    <td
      className={clsx(s.with_btn, {
        [s.btn_employ]: type === "employee",
      })}
    >
      {btnEdit && (
        <div className={s.cont}>
          <Button
            small
            txtBtn={t("ui.btn_edit")}
            onClick={(e: MouseEvent) => {
              e.stopPropagation();
              openEditModal();
            }}
          >
            <Default />
          </Button>
        </div>
      )}

      {btnView && (
        <div
          className={clsx({
            [s.cont]: true,
            [s.btn_view]: true,
            [s.active]: item.countDC === "All",
          })}
        >
          <Button
            small
            txtBtn={isUsersType ? t("ui.DC") : t("ui.view")}
            onClick={openViewModal}
            customClassName={clsx({
              [s.wide_btn]: !isUsersType,
            })}
          >
            <Default />
          </Button>
        </div>
      )}

      {btnEditStatus && (
        <div className={s.cont}>
          <Button
            small
            txtBtn={t("announcement.edit_status")}
            onClick={openEditStatusModal}
          >
            <Default />
          </Button>
        </div>
      )}

      {btnDel && (
        <div className={s.cont}>
          <Button
            small
            txtBtn={restore ? t("ui.btn_del") : t("ui.btn_restore")}
            empty
            onClick={restore ? openDelModal : openRestoreModal}
          >
            <Delete />
          </Button>
        </div>
      )}

      {btnDownload && (
        <div className={s.cont}>
          <Button
            small
            txtBtn={restore ? t("ui.btn_del") : t("ui.btn_restore")}
            empty
            onClick={restore ? openDelModal : openRestoreModal}
          >
            <Download />
          </Button>
        </div>
      )}
      {btnCustom && <div className={s.cont}>{btnCustom(item)}</div>}
    </td>
  );
};

export default ButtonResolver;
